import { render } from "./DashboardHome.vue?vue&type=template&id=4557d396&scoped=true&ts=true"
import script from "./DashboardHome.vue?vue&type=script&lang=ts"
export * from "./DashboardHome.vue?vue&type=script&lang=ts"

import "./DashboardHome.vue?vue&type=style&index=0&id=4557d396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4557d396"]])

export default __exports__